import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { HeaderUsuarioInfoHelper } from 'max-ng-lib';
import { HeaderService } from '../../../core/services/layout/header.service';
import { LayoutRefService } from '../../../core/services/layout/layout-ref.service';
import { UsuariosService } from '../../../services/usuarios.service';
import { LogoEmpresaService } from './../../../services/logo-empresa.service';
import {AuthenticationService} from '../../../core/auth/authentication.service';
import { ParametroPortalService } from '../../../services';
import { ExtratorService } from '../../../services/extrator.service';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InformacaoExtrator } from '../../pages/components/models/extrator/informacao-extrator';

@Component({
	selector: 'm-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('mHeader') mHeader: ElementRef;
	imagemCliente;
	token;

	infoUsuario: HeaderUsuarioInfoHelper = {
		cliente: null,
		ambiente: null,
		usuarioLogado: null,
		versao: null
	};
	onDestroy$ = new Subject<void>();
	infoExtrator = new InformacaoExtrator();
	utilizaExtrator = false;

	constructor(
		private router: Router,
		private layoutRefService: LayoutRefService,
		public headerService: HeaderService,
		public loader: LoadingBarService,
		public logoEmpresaService: LogoEmpresaService,
		private usuarioService: UsuariosService,
		private authenticationService: AuthenticationService,
		private parametroService: ParametroPortalService,
		private extratorService: ExtratorService
	) {
		this.token = this.authenticationService.obtenhaToken();
		setTimeout(() => {
			this.usuarioService.getUserToken()
				.subscribe(userToken => {
					this.infoUsuario = {
						cliente: userToken.nomeCliente,
						ambiente: userToken.nomeAmbiente,
						usuarioLogado: userToken.loginUsuario,
						versao: ''
					};
					this.obterInformacoesVersaoApi();
				}, error => {
					console.log(error);
				});


		}, 1000);

		this.logoEmpresaService.getLogoEmpresa()
			.subscribe(arquivo => {
				if (arquivo) {
					this.createImageFromBlob(arquivo);
				}
			});

		// page progress bar percentage
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				// set page progress bar loading to start on NavigationStart event router
				this.loader.start();
			}
			if (event instanceof RouteConfigLoadStart) {
				this.loader.increment(35);
			}
			if (event instanceof RouteConfigLoadEnd) {
				this.loader.increment(75);
			}
			if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
				// set page progress bar loading to end on NavigationEnd event router
				this.loader.complete();
			}
		});
	}

	createImageFromBlob(image: Blob) {
		const reader = new FileReader();
		reader.addEventListener('load', () => {
			this.imagemCliente = reader.result;
		}, false);

		if (image) {
			reader.readAsDataURL(image);
		}
	}

	private obterInformacoesVersaoApi() {
		this.usuarioService.getAppInfo()
			.subscribe(appInfo => {
				this.infoUsuario.versao = appInfo.buildVersion;
			}, error => {
				console.log(error);
			});
	}

	ngOnInit() {
		this.obterDadosExtrator();
	}

	ngOnDestroy(): void {
		this.onDestroy$.next();
		this.onDestroy$.complete();
	}

	obterDadosExtrator() {
		this.parametroService.obterParametroPorTipos('OUTRO_ERP').subscribe(
			param => {
				const utilizaExtrator = param[0] && param[0].valor === 'N';

				if (!utilizaExtrator) {
					return;
				}
				this.utilizaExtrator = true;

				timer(0, 30000).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
					this.extratorService.obterDadosExtratorAndBanco().subscribe(informacoesExtrator => {
						this.infoExtrator = informacoesExtrator || new InformacaoExtrator();
					});
				});
			}
		);
	}

	ngAfterViewInit(): void {
		// keep header element in the service
		this.layoutRefService.addElement('header', this.mHeader.nativeElement);
	}
}
